import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { FuseNavigationService } from '@fuse/components/navigation';
import { TranslateConfigService } from 'app/services/translate-config.service';
import { OverallFacadeService } from 'app/services/overall-facade.service';
import { OverallStoreEnum } from 'app/models/overall-store';
import { LANGUAGES_TO_SHOW } from 'app/shared/misc/shared.constant';
import { SharedService } from 'app/shared/shared.service';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-languages',
    templateUrl: './languages.component.html',
    styleUrl: './languages.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatMenuModule, MatIconModule, MatSelectModule, CommonModule, FormsModule]
})


export class LanguagesComponent implements OnInit, OnDestroy {
    activeLang: any;
    flagCodes: any;
    availableLangsNew: any;
    userLang: any;
    languagesToShow = LANGUAGES_TO_SHOW;

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private translateConfigService: TranslateConfigService,
        private overallFacadeService: OverallFacadeService,
        private sharedService: SharedService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.userLang = navigator.language;
        let browserLang = this.userLang;
        // this.availableLangsNew = SUPPORTED_LANGUAGES;
        this.availableLangsNew = this.overallFacadeService.getSpecificState(OverallStoreEnum.allData)?.['data']?.supportedLanguages;

        this.availableLangsNew = this.availableLangsNew.filter(res => this.languagesToShow.includes(res.locale));


        let lang = localStorage.getItem('langLocale');
        let availableLangFiltered = [];
        // if(lang === undefined || lang === '' || lang === null) {
        //   availableLangFiltered = this.availableLangsNew?.filter(res => {
        //     if(res.locale === browserLang) {
        //       this.translateConfigService.changeLanguage(res.locale);
        //       localStorage.setItem('currency',res.currency);
        //       localStorage.setItem('dateByCountry',res.date);
        //       localStorage.setItem('langLocale', res.locale);
        //     }
        //     else {
        //       this.translateConfigService.changeLanguage('en');
        //       localStorage.setItem('currency', 'USD');
        //       localStorage.setItem('dateByCountry', 'en-US');
        //       localStorage.setItem('langLocale', 'en');
        //     }
        //   })
        // }

        let languageSet = false;
        if (lang !== undefined && lang !== '' && lang !== null) {
            this.availableLangsNew?.filter(res => {
                if (res.locale === browserLang) {
                    this.activeLang = res;
                    languageSet = true;
                }
            });

            if (!languageSet) {
                this.availableLangsNew?.filter(res => {
                    if (res.locale === lang) {
                        this.activeLang = res;
                    }
                });
            }
        } else {
            this.availableLangsNew?.filter(res => {
                if (res.locale === browserLang) {
                    this.translateConfigService.changeLanguage(res.locale);
                    this.activeLang = res;
                    // localStorage.setItem('currency',res.currency);
                    localStorage.setItem('dateByCountry', res.date);
                    localStorage.setItem('langLocale', res.locale);
                } else {
                    this.translateConfigService.changeLanguage('en');
                    localStorage.setItem('currency', 'USD');
                    // localStorage.setItem('decimalSeparator', '.');
                    localStorage.setItem('dateByCountry', 'en-US');
                    localStorage.setItem('langLocale', 'en');
                }
            })
        }


        // availableLangFiltered?.length > 0 ? (this.activeLang = availableLangFiltered[0]) : (this.activeLang = this.availableLangsNew[0]);

        // if(this.activeLang["locale"] === 'en-UK') {
        //   this.translateConfigService.changeLanguage('en');
        // }
        // else {
        // this.translateConfigService.changeLanguage(this.activeLang["locale"]);
        // }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the active lang
     *
     * @param lang
     */
    setActiveLang(lang: any): void {
        // localStorage.setItem('currency',lang.currency);
        localStorage.setItem('dateByCountry', lang.date);
        this.sharedService.updateData(lang?.date);
        this.translateConfigService.currency.emit(true);
        this.activeLang = lang;
        this.translateConfigService.changeLanguage(lang.locale);
        localStorage.setItem('langLocale', lang.locale);
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

}

